import { createComponent } from '@/common/util/templateHelpers';
import { App, Layout } from '@/common/components';

import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';

import style from './index.module.scss';

export default createComponent('FillScreenLayout', { style }, function FillScreenLayout ({ className }, props) {
  return (
    <Layout className={className}>
      <App.Header>
        <AppHeader />
      </App.Header>

      <App.Main>
        {props.children}
      </App.Main>

      <App.Footer>
        <AppFooter />
      </App.Footer>
    </Layout>
  )
});
